import { action } from 'mobx';
import { ModalStore } from 'ui/base/modal';
import { BooleanStore, StringStore } from 'ui/base/input';
import { createRangeFilter } from 'ui/history/site_entry/site_entry_logic';
import { RangeSiteFilter } from 'services/pangolin/types';

function validate(address: string): boolean {
  const re_ipv4 = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  const re_ipv6 = /^((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?$/;
  const stripped = address.trim();
  return re_ipv4.test(stripped) || re_ipv6.test(stripped);
}

export class RangeInputStore {
  first: StringStore;
  final: StringStore;

  modal: ModalStore;
  isValid: BooleanStore;

  constructor() {
    this.first = new StringStore('');
    this.final = new StringStore('');

    this.modal = new ModalStore(false);
    this.isValid = new BooleanStore(true);
  }

  @action.bound
  commit(): RangeSiteFilter | undefined {
    const first = this.first.value;
    const final = this.final.value;
    if (validate(first) && validate(final)) {
      this.isValid.setValue(true);
      return createRangeFilter(first, final);
    }
    this.isValid.setValue(false);
    return undefined;
  }

  @action.bound
  showModal() {
    this.first.setValue('');
    this.final.setValue('');
    this.isValid.setValue(true);
    this.modal.showModal();
  }

  @action.bound
  hideModal() {
    this.modal.hideModal();
  }

  @action.bound
  toggleModal() {
    this.modal.visible = !this.modal.visible;
  }
}
